var scroll_point;
var ajax_contents = [];
var $modal = $('#modal');
var init_load_more = false;
var player;
var $scrollTop = 0;


function filterCrowdfounding(){ 
    $('.filter.nav-link').click(function(){
        $('.filter.nav-link').removeClass('active');

        var $this 		=  $(this);
        var target 		= $this.data('target');
        var value 		= $this.data('value');
        var filter_name = $this.data('filter-name'); 
    	$this.addClass('active');
 
    	console.log($('form[name="' + target + '-nav"] input[name="'+filter_name+'"]'));
        $('form[name="' + target + '-nav"] input[name="'+filter_name+'"]').val(value);
        $('form[name="' + target + '-nav"] input[name="page"]').val(0);
        
        $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {            
        	console.log(result);
        	$('#' + target + '-list').html(result);
        	var numPages = updateNumPages(target);
        }
        });
    }); 
}


function updateNumPages(target){

    $.ajax({
        data:$('form[name="'+target+'-nav"]').serialize() + "&numpages=true",
        dataType:'html',
        success:function(data){        	        	
            $('form[name="'+target+'-nav"] input[name="num_pages"]').val(data);    

            var current_page = Number($('form[name="' + target + '-nav"] input[name="page"]').val()+1);
            var total_page   =  Number($('form[name="' + target + '-nav"] input[name="num_pages"]').val());
            if( current_page>=total_page ){            	
                $('.more-results[rel="'+target+'"]').hide();
                
            }else{
                  $('.more-results[rel="'+target+'"]').show();
            }
        }
    });    
}


function postUpdateQty(form){
	$.ajax({data: form.serialize(), success: function (data) {
		if (data.status === 'ok') {
			if(data.total === 0){
				$('.cart-counter').removeClass('label-danger').addClass('label-default');
			}else{
				$('.cart-counter').addClass('label-danger').removeClass('label-default');
			}
			$('.cart-totals').html(data.total_amount);
			$('.cart-counter').html(data.total);

            ajaxContent('.mini-cart.ajax-content');
            ajaxContent('.cart-content.ajax-content');

			if(data.callback_function){
				setTimeout(function(){
					try{
						window[data.callback_function]();
					}catch (Error){ }

				},500);
			}
			
		} else if (data.status === 'error') {
			form_submit_response('#messages_product_view', 'error', data.error);
		} else {
			form_submit_response('#messages_product_view', 'error', 'An unknown error occurred. Please try again later');
		}
	}});
}
function updateQty(){
	$('.products-cart-container .cart-item .touchspin-up').click(function(){
		var qty = $(this).prev().val();
		qty = parseInt(qty)+1;
		console.log(qty);
		$(this).prev().val(qty);
		var form = $('form[name="update_qty"]');
		postUpdateQty($(this).closest('form[name="update_qty"]' ));
		
		
	});
	$('.products-cart-container .cart-item .touchspin-down').click(function(){
		var qty = $(this).next().val();
		if(qty>1){
			qty = parseInt(qty)-1;
			$(this).next().val(qty);
			postUpdateQty($(this).closest('form[name="update_qty"]' ));
		}
	});
	$( '.products-cart-container form[name="update_qty"] input[name="qty"]' ).change(function() {
	  	postUpdateQty($(this).closest('form[name="update_qty"]' ));
	});
	return false;
}
function updateQtyCart(){
	$('.cart-item .touchspin-up').click(function(){
		var qty = $(this).prev().val();
		qty = parseInt(qty)+1;
		console.log(qty);
		$(this).prev().val(qty);
		var form = $('form[name="update_qty"]');
		postUpdateQty($(this).closest('form[name="update_qty"]' ));		
	});
	$('.cart-item .touchspin-down').click(function(){
		var qty = $(this).next().val();
		if(qty>1){
			qty = parseInt(qty)-1;
			$(this).next().val(qty);
			postUpdateQty($(this).closest('form[name="update_qty"]' ));
		}
	});
	$( 'form[name="update_qty"] input[name="qty"]' ).change(function() {
	  	postUpdateQty($(this).closest('form[name="update_qty"]' ));
	});
	
	return false;
}

function updateCartForm(){
    $('.cart-content .touchspin-up').click(function(){
        var qty = $(this).prev().val();
        qty = parseInt(qty)+1;
        console.log(qty);
        $(this).prev().val(qty);
        var form = $('form[name="update_qty"]');
        postUpdateQty($(this).closest('form[name="update_qty"]' ));
    });
    $('.cart-content .touchspin-down').click(function(){
        var qty = $(this).next().val();
        if(qty>1){
            qty = parseInt(qty)-1;
            $(this).next().val(qty);
            postUpdateQty($(this).closest('form[name="update_qty"]' ));
        }
    });
    $( 'form[name="update_qty"] input[name="qty"]' ).change(function() {
        postUpdateQty($(this).closest('form[name="update_qty"]' ));
    });

    return false;
}


$(function(){
	setHeightsGen();
	$(window).resize(function(){setHeightsGen();});
	$('.toggle-sub').click(function(){
		var this_click = $(this);
		var was_open = 0;
		if(this_click.parent().hasClass('open-toggle')){
			was_open = 1;
		}
		$('.open-toggle').each(function(){
			$(this).removeClass('open-toggle');
		});
		if(was_open===0){
			this_click.parent().addClass('open-toggle');
		}
			

		
	});
	
	if ("ontouchstart" in window || navigator.msMaxTouchPoints){
		$('body').addClass('touch');
	} else {
		$('body').addClass('no-touch');
	}

	if($(".hero-carousel" ).length) {
		$( "body" ).addClass('with-hero');
	}else{
		$( "body" ).addClass('no-hero');
	}
	
	if($('.item-breaking').length>0){
		$('#breaking #modal-breaking').modal('show');
	}
	
	setHeroHeight();
	
	$('.producs-details  .touchspin-up').click(function(){
		var qty = $(this).prev().val();
		qty = parseInt(qty)+1;
		$(this).prev().val(qty);
	});
	$('.producs-details  .touchspin-down').click(function(){
		var qty = $(this).next().val();
		if(qty>1){
			qty = parseInt(qty)-1;
			$(this).next().val(qty);
		}
	});

	$('body').addClass('loaded');

	/*
	if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ) {
		$('.transitionmask').removeClass('slidemaskin').addClass('slidemaskout');
	} else {
		$('.transitionmask').remove();
	}
	*/
	//var $grid = $('.masonry_sub_pages').masonry();
	
	$('.news-categories .filter').click(function(){	
		$this = $(this);
		if(!$this.hasClass('active')){
			$('.news-categories .filter.active').removeClass('active');
			$this.addClass('active');	
			$('.news-grid li').remove();
			var target = $this.attr('rel');	
			$('form[name="'+target+'-nav"] input[name="type"]').val($this.data('category'));			
			init_load_more = true;
			more(target,init_load_more);
			init_load_more = false;
		}
		
		return false;
	}); 

	$('.houses-carousel .item img').click(function(){	
		var img = $(this).data('img');	
		$('.house-album .pic img').attr("src", img);	
		return false;
	});

	$(window).resize(function(){
		setHeightsProducts();
	});
	var $listProducts     = $( '.recent-products-container' );
	var	$itemsProducts    = $listProducts.find( '.eq-height' );
	$( window ).on( 'resize', setHeightsProducts($listProducts,$itemsProducts, 12) );
	$listProducts.find( 'img' ).on( 'load', setHeightsProducts($listProducts,$itemsProducts, 12) );	
	
	
	function setHeightsProducts(){		
		var $list     = $( '.recent-products-container'),
            $items    = $listProducts.find( '.eq-height'),
            perRow 	  = 12;

        $items.css( 'height', 'auto' );

		for( var i = 0, j = $items.length; i < j; i += perRow ){
			var maxHeight   = 0,
				$row        = $items.slice( i, i + perRow );
	
			$row.each( function(){
				var itemHeight = parseInt( $( this ).outerHeight() );
				if ( itemHeight > maxHeight ) {
					maxHeight = itemHeight;
				}
			} );
			$row.css( 'height', maxHeight );
		}
	}	
	
	var w = $(window).innerWidth();
	
	$(window).resize(function(){
		setHeroHeight();
	});
	
	function setHeroHeight() {
		var bcontent;
		var bcontrols;
		var bdots;
		
		var h = $(window).innerHeight();
		var w = $(window).innerWidth();		
		var i = $('.hero .item').innerHeight();
		
		
		
		var diff = i - h;
		
		if (w <= 567) {
			bcontrols = '60%';
		} else if (w <= 767) {
			bcontent  = diff + 205;
			bcontrols = diff + 30;
			bdots = diff + 20;
		} else if (w <= 1024) {
			bcontent  = diff + 200;
			bcontrols = diff + 95;
			bdots = diff + 20;
		} else {
			bcontent  = diff + 100;
			bcontrols = diff + 100;
			bdots = diff + 30;
		}
		
		if($('body').hasClass('section-home')){
			bcontent = bcontent + 60;
			bcontrols = bcontrols + 60;
			bdots = bdots + 60;
		}
		$('.hero-content').css('bottom', bcontent);
		
		$('.hero-controls').css('bottom', bcontrols);	
		$('.slick-dots').css('bottom', bdots);
		
	}
	
	$( window ).resize( function(){		
		if ($(window).innerWidth()==w) {
			w = $(window).innerWidth();	
			return;
		}else{
			w = $(window).innerWidth();	
			initInfographics();
			
			if($('body').hasClass('show-responsive-nav')){
				$('body').removeClass('show-responsive-nav');
				$('.burger div').removeClass('open');
			}
			$('body.show-mini-cart').removeClass('show-mini-cart');	
			$('.responsive-products-nav .open').removeClass('open');		
		}
	});
		
	$(document).on('click', ".ajax-modal", function (e) {

        try{
           e.preventDefault();			
           if($(this).attr("href")){
				openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));	
			}else{
				openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));
			}
			
        }catch(Error){
            console.log(Error);
        }
        return false;
    });
	$('.share-trigger').click(function(){
		$('body').toggleClass('show-shares');
		return false;
	});
	$('.news-item .primary-actions.share').click(function(){
		$('.news-item.show-news-shares').removeClass('show-news-shares');
		$(this).closest('.news-item').addClass('show-news-shares');
		return false;
	});
	
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		$('body').addClass('sticky-phones');
		setTimeout(function(){
			$('body').addClass('show-sticky-phones');
		},10);
	}
	
	$(document).on('scroll',function() {  
		$scrollTop = $(window).scrollTop();

		if($scrollTop > 150) {
			 $(".main-nav").addClass("sticky");
			 $(".logo").removeClass("logo").addClass("sticky-logo");
			 $(".responsive-nav").addClass("sticky-responsive-nav");
		}else{
			$(".main-nav").removeClass("sticky");
			$(".sticky-logo").removeClass("sticky-logo").addClass("logo");
			$(".responsive-nav").addClass("sticky-responsive-nav");
		}
		
		if($scrollTop > $('.home-news').innerHeight()-70) {
			 $(".news-list .news-categories").addClass("sticky");
		}else{
			$(".news-list .news-categories").removeClass("sticky");
		}
		
		if($('body').hasClass('with-hero')){
			scroll_point = $('.hero').innerHeight()-$('.main-nav').innerHeight();
		} else {
			scroll_point = 150;
		}
		if($scrollTop > scroll_point) {
			 $(".products-nav").addClass("sticky");
			 $(".responsive-products-nav").addClass("sticky");
		}else{
			$(".products-nav").removeClass("sticky");
			$(".responsive-products-nav").removeClass("sticky");
		}
		 var phone_scroll;
		if($('body').hasClass('section-home')) {
			phone_scroll = $(window).innerHeight();
		}else{
		 	phone_scroll = 300;
		}
		if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ) {
			if($scrollTop > phone_scroll) {
				$('body').addClass('sticky-phones');
				setTimeout(function(){
					$('body').addClass('show-sticky-phones');
				},10);
				
			}else{
				$('body').removeClass('sticky-phones');
				setTimeout(function(){
					$('body').removeClass('show-sticky-phones');
				},10);
			}
		}

		
		
		if($('.crowdfunding-details-header')) {
			if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ) {
				if($('body').hasClass('with-hero')){
					var gfd = $('.crowdfunding-details-header').innerHeight() - ($('.crowdfunding-details-stats').innerHeight() / 2)  - $('header .main-nav').innerHeight();
				}else{
					var gfd = $('.crowdfunding-details-header').innerHeight() - $('header .main-nav').innerHeight();
				}
				
				if($scrollTop >  gfd) {
					$('body').addClass('sticky-cf-header');
				}else{
					$('body').removeClass('sticky-cf-header');
				}
			}
		}
	});
	
	$('.nav-basket').click(function(){
		if($('body').hasClass('show-mini-cart')){
			$('body').removeClass('show-mini-cart');
		}else{
			if($('body').hasClass('show-responsive-nav')){
				$('body').removeClass('show-responsive-nav');
				$('.burger div').removeClass('open');
				
				setTimeout(function(){ 
					$('body').addClass('show-mini-cart');
				}, 200);

			}else{
				$('body').addClass('show-mini-cart');
			}			
		}
		return false;
	});	
	$('#nav-icon1').click(function(){
		if($('body').hasClass('show-responsive-nav')){
			$('body').removeClass('show-responsive-nav');
		}else{
			if($('body').hasClass('show-mini-cart')){
				$('body').removeClass('show-mini-cart');
				setTimeout(function(){ 
					$('body').addClass('show-responsive-nav');
				}, 200);

			}else{
				$('body').addClass('show-responsive-nav');
			}
		}
		return false;
	});	
	
	$('.modal-overlay').click(function(){
		if($('body').hasClass('show-responsive-nav')){
			$('body.show-responsive-nav').removeClass('show-responsive-nav');
			$('.burger div').removeClass('open');
		}
		$('body.show-mini-cart').removeClass('show-mini-cart');		
	});	

	
	/*$('input').iCheck({
		checkboxClass: 'icheckbox_minimal',
		radioClass: 'iradio_minimal',
		increaseArea: '20%' // optional
	});*/
	
	$('.main-nav #nav-icon1,.main-nav #nav-icon2,.main-nav #nav-icon3,.main-nav #nav-icon4').click(function(){
		$(this).toggleClass('open');
		return false;
	});
	
	$('.responsive-nav .top-page').click(function(){
		$(this).parent().toggleClass('open');
		return false;
	});
		
	$('.categories-toggle,.subcategory-toggle').click(function(){
		$(this).parent().toggleClass('open');
		return false;
	});
	
	$('.first_lvl_collapse').click(function(){
		//$(this).parent().parent().toggleClass('open');
		return false;
	});
	$('.second_lvl_collapse').click(function(){
		//$(this).parent().toggleClass('sub_open');
		return false;
	});
	
	//$('.locations-container').click(function(){
	//	$('.home-locations').toggleClass('show-map');
	//});
	
	$(document).on("click", '.more-results', function ($e) {
		var target = $(this).attr('rel');	
		more(target,init_load_more);
		return false;
	});

	$(document).on('ifChecked','input[name="primary_billing_address"],input[name="primary_shipping_address"]',function(){
		var checked = $(this).is(':checked');
        var id = $(this).val();
        $.ajax({data: {module: 'addresses', 'action': 'set-primary', 'type': $(this).data('type'), id: id}, success: function (data) {
            if (data.status === 'ok') {
                form_submit_response('', 'success', data.message, true);
            } else if (data.status === 'error') {
                form_submit_response('form[name="login_form"]', 'error', data.error);
            } else {
                form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
            }
        }
        });
        return false;
    });	
	$('select').select2();
	callbacks();
    ajaxContent();
	initInfographics();	
});
function initHomeSonsors(){
	var sponsors_options = {
		dots: false,
		infinite: true,
		appendArrows:false,
		speed: 900,
		slidesToShow: 12,
		variableWidth: true,
		autoplay: true,
		autoplaySpeed: 900,
	};
	$("#owl-sponsors").slick(sponsors_options);
	var sponsors_options2 = {
		dots: false,
		infinite: true,
		appendArrows:false,
		speed: 900,
		slidesToShow: 17,
		variableWidth: true,
		autoplay: true,
		autoplaySpeed: 900,
	};
	$("#owl-sponsors-small").slick(sponsors_options2);
}
function initPAgeSponsors(){

	var width_latest = $(window).width(); 

	var sponsors_options = {
		dots            : false,
		infinite        : $('#owl-sponsors .item').length>8?true:false,
		appendArrows    :false,
		speed           : 900,
		variableWidth   : true,
		slidesToShow	: 8,
		autoplay        :  $('#owl-sponsors .item').length>8?true:false,
		autoplaySpeed   : 900,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4,
				arrows: false,
				slidesToScroll: 4,
				autoplay:  $('#owl-sponsors .item').length>4?true:false,
				infinite: $('#owl-sponsors .item').length>4?true:false,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 3,
				arrows: false,
				autoplay:  $('#owl-sponsors .item').length>3?true:false,
				infinite: $('#owl-sponsors .item').length>3?true:false,
				
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			  	slidesToShow: 2,
				autoplay:  $('#owl-sponsors .item').length>2?true:false,
				infinite: $('#owl-sponsors .item').length>2?true:false,
				arrows: false,
			  }
			}
		]
	};
	$("#owl-sponsors").slick(sponsors_options);
}

function blinkCart(){
    $('.nav-basket').animate({opacity:0.1},300,function(){
        $('.nav-basket').animate({opacity:1},200,function(){
            $('.nav-basket').animate({opacity:0.1},300,function(){
                $('.nav-basket').animate({opacity:1},200,function(){

                });
            });
        });
    });
}
function initHouseDetailsSponsors(){
	var gridContainer;
	gridContainer = new AnimOnScroll(document.getElementById('sponsors-grid'), {
		minDuration: 0.4,
		maxDuration: 0.7,
		viewportFactor: 0.2
	});
}

function initCopyText(){	
	var btns = document.querySelectorAll('.clipboard');		
    var clipboard = new Clipboard(btns);    
    $('.clipboard').click(function(){
    	var $this = $(this);
    	var clipboard_label = $this.data('label');    	
    	if (typeof clipboard_label === "undefined") {
    		clipboard_label = 'Copied!';
    	}    	
		$('.copy-msg').remove();
		$(this).append('<div class="copy-msg">'+clipboard_label+'</div>');
		setTimeout(function(){
			$('.copy-msg').addClass('show');
		},50);
		setTimeout(function(){
			$('.copy-msg').remove();
		},2000);	

		copyToClipboard($this);

	});
	clipboard.on('success', function(e) {
        console.log(e);
    });
    clipboard.on('error', function(e) {
        console.log(e);		
    });	   	
}

function copyToClipboard($e) {
	var $temp = $("<input>");
	$e.append($temp);
	$temp.val($e.data('clipboard-text')).select();
	document.execCommand("copy");
	$temp.remove();
}


function initSearch(){
	 var morphSearch = $('#morphsearch'),
            input = $('.search-button'),
            ctrlClose = $('span.morphsearch-close'),
            isOpen = false,
            isAnimating = false,
            toggleSearch = function (evt) {
                // return if open and the input gets focused


                var offsets = morphsearch.getBoundingClientRect();
                if (isOpen) {
                    morphSearch.removeClass('open');
					$('body').removeClass('search-open');
                    $('.morphsearch-content .search-results').empty();
					$('.morphsearch-input').val('');
					//classie.remove( morphSearch, 'open' );

                    // trick to hide input text once the search overlay closes
                    // todo: hardcoded times, should be done after transition ends
					
                    if (input.value !== '') {
                        setTimeout(function () {
                            morphSearch.addClass('hideInput');
                            setTimeout(function () {
                                morphSearch.removeClass('hideInput');
                                input.value = '';
                            }, 300);
                        }, 500);
                    }

                    input.blur();
                }
                else {
					$('body').addClass('search-open');
					$('body.map-open').removeClass('map-open');
					$('body.menu-open').removeClass('menu-open');
                    morphSearch.addClass('open');
                }
                isOpen = !isOpen;
                return false;
            };

    $('.morphsearch-content .primary-actions').click(function(){
        morphSearch.removeClass('open');
        $('body').removeClass('search-open');
        isOpen = !isOpen;
    });
    // events
    input.on('click', toggleSearch);
    ctrlClose.on('click', toggleSearch);
    // esc key closes search overlay
    // keyboard navigation events
    $(document).on('keydown', function (ev) {
        var keyCode = ev.keyCode || ev.which;
        if (keyCode === 27 && isOpen) {
            toggleSearch(ev);
        }
    });
}

function initPagesAlbum(){
	$(".page-image").fancybox({
		helpers: {
			overlay: {
				locked: false
			}
		},
		'hideOnContentClick': true,
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
	});
	$('#owl-page-ablum').slick({
		  dots: false,
		  infinite: false,
		  speed: 300,
		  slidesToShow: 4,
		  arrows: false,
		  slidesToScroll: 4,
		  responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3,
				arrows: false,
				slidesToScroll: 3,
				infinite: true,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2,
				arrows: false,
				slidesToScroll: 2
				
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 2,
				arrows: false,
				slidesToScroll: 2
			  }
			}
		]
	});
}
function missingchildrenCarousel(){
	$('#missingchildren_carousel').hide();
	var $slider = $('#missingchildren_carousel')
        .on('init', function(slick) {
            console.log('fired!');
            $('#missingchildren_carousel').fadeIn(3000);
        })
       .slick({
		  dots: false,
     	  arrows: false,
		  infinite: true,
		  autoplay: true,
   		  autoplaySpeed: 4000,
		  speed: 900,
		  slidesToShow: 8,
		  lazyLoad: 'ondemand',
		  responsive: [
			{
			  breakpoint: 1600,
			  settings: {
				slidesToShow: 7,
				arrows: false,
				infinite: true,
			  }
			},
			{
			  breakpoint: 1250,
			  settings: {
				slidesToShow: 6,
				arrows: false,
				infinite: true,
			  }
			},
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4,
				arrows: false,
				infinite: true,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2,
				arrows: false,				
			  }
			}
		]
	});
}

function initHousesAlbum(){
	$('.houses-carousel').slick({
		  dots: false,
		  infinite: false,
		
		  speed: 300,
		  slidesToShow: 4,
		
		  slidesToScroll: 4,
		  responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3,
				arrows: false,
				slidesToScroll: 3,
				infinite: true,
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 2,
				arrows: false,
				slidesToScroll: 2
				
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 2,
				arrows: false,
				slidesToScroll: 2
			  }
			}
		  ]
	});
}

function initNewsShares(){
	$('.rrssb-buttons').rrssb({
		title: '<?php echo $title;?>',
		image : '<?php echo $image;?>',
		description : '<?php echo $description;?>',
		url: '<?php echo $thislink;?>'
	});
}

function ajaxContent(c){


    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {


        ajax_contents.push(
            {
                'content':$(this).data('ajaxContent'),
                'target': $(this)
            }
        );
    });

    loadAjaxContent();
}

function missingchildrenFancybox() {
	$(".poster-link").fancybox({
		helpers: {
			overlay: {
				locked: false
			}
		},
		'hideOnContentClick': true,
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
	});
}

function newsalbumFancybox() {
	$(".modal-img").fancybox({
		helpers: {
			overlay: {
				locked: false
			}
		},
		'hideOnContentClick': true,
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'speedIn'		:	600, 
		'speedOut'		:	200, 
	});
}

function updateAccountForm() {

    $('form[name="my_account_form"]').addClass('ready');
    $('form[name="my_account_form"]').validate({
        rules: {
            'name': 'required',
            'surname': 'required',
            'username': 'required',
            'password': {
                minlength: 5
            },
            'password_verify': {
                minlength: 5,
                equalTo: "#password"
            },
            'captcha_code': 'required'
        },
        messages: {
            'name': 'Required',
            'surname': 'Required',
            'username': 'Required',
            'password': {
                minlength: "! Must be at least 5 characters long"
            },
            'password_verify': {
                required: 'Required',
                minlength: "! Must be at least 5 characters long"
            },
            'captcha_code': 'Required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="my_account_form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    form_submit_response('form[name="my_account_form"]', 'success', 'Account details have been succesfully updated', true);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="my_account_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="my_account_form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}



function more(target,init_load_more){



    var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
    if(init_load_more){
		next_page = 0;
	}


	var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val());
	
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	$('.more-results[rel="'+target+'"]').addClass('loading');
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize(),
		dataType:'html',
		success:function(data){
			$newItems = $.parseHTML( data );
			$.each( $newItems, function( i, el ) {
				$(el).data('duration', i ).appendTo('#'+target+'-list');			
			});		
			if(target=='news')	{
				initNewsGrid();	
			}			
			if(next_page==all_pages-1){
				$('.more-results[rel="'+target+'"]').hide();
			}else{
				$('.more-results[rel="'+target+'"]').removeClass('loading');		
			}
		}
	});
}

function initLinksGroup () {
	/*var $list       = $( '.what-we-do-mm' );
	var	$items      = $list.find( '.sub_pages_2' );	
	var perRow 	  = $items.length;
	$('.mega-menu .what-we-do').css( 'height', 'auto' );
	
	for( var i = 0, j = $items.length; i < j; i += perRow )
	{
		var maxHeight   = 0,
			$row        = $items.slice( i, i + perRow );

		$row.each( function(){
			var itemHeight = parseInt( $( this ).outerHeight() );
			if ( itemHeight > maxHeight ) {
				maxHeight = itemHeight;
			}
		} );
		$('.mega-menu .what-we-do').css( 'min-height', maxHeight+30);	
	}*/
}
$(window).resize(function(){
	setTimeout(function(){
		initLinksGroup ();
	},100);
	
});

function initInfographics() {
	var $list       = $( '.home-infographic' );
	var	$items      = $list.find( '.infographic-item' );
	setHeights($list,$items,4);
	$( window ).on( 'resize', setHeights($list,$items,4) );
	$list.find( 'img' ).on( 'load', setHeights($list,$items,4) );	
}

function setHeights($list,$items,perRow){
	$items.css( 'height', 'auto' );

	//var perRow = perRow;
	//if( perRow === null || perRow < 2 ) return true;

	for( var i = 0, j = $items.length; i < j; i += perRow )
	{
		var maxHeight   = 0,
			$row        = $items.slice( i, i + perRow );

		$row.each( function()
		{
			var itemHeight = parseInt( $( this ).outerHeight() );
			if ( itemHeight > maxHeight ) maxHeight = itemHeight;
		});
		$row.css( 'height', maxHeight );
	}
}

function setHeightsGen(){		
	var $list     = $( '.eq-height-row' );
	var	$items    = $list.find( '.eq-height' );
	$items.css( 'height', 'auto' );
	perRow = 12;
	for( var i = 0, j = $items.length; i < j; i += perRow )
	{
		var maxHeight   = 0,
			$row        = $items.slice( i, i + perRow );

		$row.each( function(){
			var itemHeight = parseInt( $( this ).outerHeight() );
			if ( itemHeight > maxHeight ) {
				maxHeight = itemHeight;
			}
		} );
		$row.css( 'height', maxHeight );
	}
}

function loadAjaxContent(){

    if(ajax_contents.length > 0){
        var target = ajax_contents[0].target,
        	content =  ajax_contents[0].content;

        if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }

        target.addClass('ajax-load-initiated');

        target.load(content ,function(){
            var uniq = (Math.random() + '').replace('0.', '');
            target.removeClass('ajax-load-initiated');

            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}

function callbacks(c) {
    var container = c || '';
    ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
                var c = $(this).data();
                for (var i in c) {
                    if (i.indexOf('fn') === 0 && c[i] !== '') {
                        var fn = c[i];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ](params, function(){
                                    window[callbackAfter](callbackAfterParams);
                                });
                            } else {
                                window[ fn ](params);
                            }
							$(this).addClass('callbacks-executed');
                        } catch (Error) {
                            console.log(Error + ' '+fn);
                        }
                    }
                }
            }
        }
    });

}

function closeMinicart(){
	$('.close-mini-cart').click(function(){
		$('body').removeClass('show-mini-cart');
		return false;
	});
}

function confirmation(callback, id, message) {
    var c = confirm(message);
    if (c) {
        callback(id);
    }
}

function form_submit_response(target, type, message, r) {
    alert(message);
    return false;
	/*
    var redirect = r || false;
    $('#growls').empty();
    if (type === 'error') {
        $.growl.error({ duration:6000,title:'',message: message, location: 'tr',size:'large'  });
    } else if (type === 'warning') {
        $.growl.warning({ duration:6000,title:'',message: message, location: 'tr',size:'large'   });
    } else if (type === 'success') {
        $.growl.notice({ duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    } else {
        $.growl({duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    }
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }*/
}

function removeFromCart(id) {
    $.ajax({data: {module: 'sales', action: 'remove-from-cart', product: id}, success: function (data) {
        if (data.status === 'ok') {
            ajaxContent('.mini-cart.ajax-content, .cart.ajax-content');

            if(data.total === 0){
                $('.cart-counter').removeClass('label-danger').addClass('label-default');
            }else{
                $('.cart-counter').addClass('label-danger').removeClass('label-default');
            }
            $('.cart-totals').html(data.total_amount);
            $('.cart-counter').html(data.total);
            form_submit_response('', 'success', data.message);
        } else if (data.status === 'error') {
            form_submit_response('', 'error', data.error);
        } else {
            form_submit_response('', 'error', 'An unknown error occurred. Please try again later');
        }
    }});
}

function initCheckboxes(){
	/*$('input').iCheck({
		checkboxClass: 'icheckbox_minimal',
		radioClass: 'iradio_minimal',
		increaseArea: '20%' // optional
	});/*/
}

function openAjaxModal(href,$mm){
	
    $m = $mm || $modal;

    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        //skinFormElements('#'+$m.attr('id'));
        callbacks('#'+$m.attr('id'));
    });
}

function supportUsToggles(){
	$('.support-us:not(.callbacks-executed) .first_lvl_support_collapse').click(function(){
		if($(this).parent().hasClass('open')){
			$('.support-us .first_lvl_support_collapse').each(function(){
				if($(this).parent().hasClass('open')){
					$(this).parent().removeClass('open');
				}
			});
		}else{
			$('.support-us .first_lvl_support_collapse').each(function(){
				if($(this).parent().hasClass('open')){
					$(this).parent().removeClass('open');
				}
			});
			$(this).parent().addClass('open');
		}		
		return false;
	});
}

function initReactNow(){
	$('.react-actions .action').click(function(){
		$('.react-actions .action.active').removeClass('active');
		$(this).addClass('active');
		$('.hidden-section.show').removeClass('show');
		$('.hidden-section.'+$(this).data('action')).addClass('show');
		if($('body').hasClass('touch')){
			$('.modal-white ,.react-actions').animate({scrollTop: $('.react-actions .inner-content').innerHeight()+$('.react-actions .react-buttons').innerHeight()+150},'slow');
		}
		return false;
	});
}

function initSocialFeed(){
	var $grid = $('.grid').masonry();
	$grid.imagesLoaded().progress( function() {
	  $grid.masonry('layout');
	});
}

function initArticlesList(){
	var gridContainerArticles;
	gridContainerArticles = new AnimOnScroll(document.getElementById('articles-list'), {
		minDuration: 0.4,
		maxDuration: 0.7,
		viewportFactor: 0.2
	});
}

function initNewsGrid(){
	var gridContainer;
	gridContainer = new AnimOnScroll(document.getElementById('news-list'), {
		minDuration: 0.4,
		maxDuration: 0.7,
		viewportFactor: 0.2
	});
}

function initWhereWeAre_old(){
	var gridContainer;
	gridContainer = new AnimOnScroll(document.getElementById('where-we-are-list'), {
		minDuration: 0.4,
		maxDuration: 0.7,
		viewportFactor: 0.2
	});
	$('select').on("select2:select", function(e) { 
		var type = $('select[name="house-categories"]').val();
		var service = $('select[name="house-services"]').val();
		
		$('.where-we-are-list li').each(function(){
			var this_house = $(this);
			this_house.addClass('hidden-service');
			this_house.addClass('hidden-type');		
		});
		$('.where-we-are-list li').each(function(){
			var this_house = $(this);
			if(this_house.hasClass(service) || service==="all-services"){
				this_house.removeClass('hidden-service');		
			}
			if(this_house.hasClass(type) || type==="all-types"){
				this_house.removeClass('hidden-type');		
			}					
		});
		initWhereWeAre();
	});
}
function initWhereWeAre(){
	$('select').on("select2:select", function(e) { 
		var type = $('select').val();
		alert(type);
	});
	
}


function initSponsors(){
	var gridContainer;
	gridContainer = new AnimOnScroll(document.getElementById('sponsors-list'), {
		minDuration: 0.4,
		maxDuration: 0.7,
		viewportFactor: 0.2
	});
	$('.sponsors-filters .letters a').click(function(){
		var id = $('.sponsors-list .letter-'+$(this).data('letter')).prev().attr('id');
		$('html, body').animate({
			scrollTop: $("#"+id).offset().top
		}, 500);
		return false;
	});
}




function initProductVerticalThumbs(){
	var thumbs_slider = $('.thumbs-slider').slick({
		arrows: true,
		dots: false,
		slidesToShow: 3,
		centerPadding: "10px",
		draggable: true,
		vertical: true,
		speed: 500,
		useTransform: true,
		cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
		adaptiveHeight: true,
		responsive: [
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 3,
				vertical: false,
			  }
			}
		]
	});
	$('.thumb').click(function(e){
		var new_img = $(this).data('imgsrc');
		$('.products-main-image img').attr("src", new_img);	
		var id = $(this).data('id');
		$(".select-type").val(id).trigger("change");
		
		return false;
	});
}

function initDesignSelect(){
 	$('.select-type').on("change", function(e) {
		var product_id = $('.select-type').val();
		var new_img = $('.item-'+product_id).data('imgsrc');
		$('.products-main-image img').attr("src", new_img);		
		$('.thumbs-slider').slick('slickGoTo', $('.item-'+product_id).data('slick-index'));
	});

}

function initHeaderBanner()
{

    if(getCookie('cookie_consent')!=1){

        $('.header-banner').addClass('display');
        $(".main-nav").addClass('start');

        $(document).on('scroll',function() {
            if($(window).scrollTop() > 150 && $('.header-banner').css('display') === 'block') {
                 $(".main-nav").addClass('push');
            } else {
                $(".main-nav").removeClass('push');
            }
        });
        $('.banner-close').on('click', function(){
            $('.header-banner').removeClass('display');
            $(".main-nav").removeClass('push');
            $(".main-nav").removeClass('start');

            setCookie('cookie_consent',1,30);

        });
    }
}


function captchaCallback(params)
{
	id = params[0];
	key = params[1];

    var interval = setInterval(function(){
        if(typeof (grecaptcha)!='undefined'){
            clearInterval(interval);
            grecaptcha.render(id, {'sitekey' : key, 'theme' : 'light'});
        }
    },500);
}


function scroll2element(el) {
    var position = $(el).offset();
    var $padding = $('body').css('paddingTop').replace('px', '');
    var y = position.top - $padding;

    $('html, body').stop().animate({
        scrollTop: y
    }, 'slow');

}

